// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freight-options[data-v-5e8f987c]{display:grid;grid-template-columns:repeat(2,1fr);gap:10px 30px}@media(max-width:599px){.freight-options[data-v-5e8f987c]{grid-template-columns:1fr}}.freight-options__ship-from[data-v-5e8f987c],.freight-options__ship-to-flex[data-v-5e8f987c]{gap:6px;padding-left:32px}.freight-options__checkbox-row-spacer[data-v-5e8f987c]{flex:0 0 32px;width:32px;height:0;margin-left:12px;visibility:hidden;pointer-events:none}", ""]);
// Exports
module.exports = exports;
